import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=0a51f873&"
import script from "./productOrder.vue?vue&type=script&lang=js&"
export * from "./productOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports